import { Select,Form} from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsXiangMuBanBenListQuery } from '../../store/BnsKeJiApi';
function SketchSelect(props) {    
    const {data,isSuccess} = useBnsXiangMuBanBenListQuery({bxmbb_bxm_id:props.bxm_id},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);                
                const newArr = data.Result.map(item => {
                    const {bxmbb_id:key,bxmbb_name,} = item;
                    return item = {value:key,label:bxmbb_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.FormStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default SketchSelect
